// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

import './assets/css/global.css'

import ElementUI, { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

router.beforeEach((to, from, next) => {
  /* 判断该路由是否需要登录权限 */
    if(to.meta.requireAuth){
        //是否登录
        if(!sessionStorage.getItem('token')){
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
        }else{
             next()
        }
    }else{
        next();
    }
})

Vue.use(ElementUI);

Vue.prototype.$http = axios

//Vue.prototype.$http.defaults.baseURL = 'http://127.0.0.1:8080/api'  //关键代码
Vue.prototype.$http.defaults.baseURL = 'https://jicha.rong-sheng.com/'  //关键代码

Vue.config.productionTip = false

Vue.prototype.$message=Message;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js